import { CONSTANTS } from "src/constants";
import * as yup from "yup";
export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .required("Please enter email")
    .email("Invalid email address")
    .matches(CONSTANTS.VALIDATIONS.EMAIL, "Invalid email address"),
  password: yup.string().trim().required("Please enter password"),
});
